import { WORLD } from "@clubap/shared";
import { Container, Graphics } from "pixi.js";

/**
 * El taller: una rejilla y nada más.
 *
 * Es el único escenario del juego que no representa un sitio, y por eso es el único que
 * se dibuja sin gracia a propósito. Acá se viene a mirar el fondo de OTRA sala con su
 * polígono caminable encima; cualquier cosa con carácter propio competiría con lo que se
 * está tratando de ver, y un fondo oscuro se comería la línea del polígono.
 *
 * La rejilla es además una regla: 40 píxeles de paso, con una línea más marcada cada
 * 200, para poder contar lo que uno arrastra sin abrir nada.
 */
export function taller(): Container {
  const scene = new Container();

  const fondo = new Graphics();
  fondo.rect(0, 0, WORLD.width, WORLD.height).fill(0x243b53);
  scene.addChild(fondo);

  const rejilla = new Graphics();

  for (let x = 0; x <= WORLD.width; x += 40) {
    rejilla.moveTo(x, 0).lineTo(x, WORLD.height);
  }
  for (let y = 0; y <= WORLD.height; y += 40) {
    rejilla.moveTo(0, y).lineTo(WORLD.width, y);
  }
  rejilla.stroke({ width: 1, color: 0xffffff, alpha: 0.08 });

  const gruesas = new Graphics();
  for (let x = 0; x <= WORLD.width; x += 200) {
    gruesas.moveTo(x, 0).lineTo(x, WORLD.height);
  }
  for (let y = 0; y <= WORLD.height; y += 200) {
    gruesas.moveTo(0, y).lineTo(WORLD.width, y);
  }
  gruesas.stroke({ width: 2, color: 0xffffff, alpha: 0.16 });

  scene.addChild(rejilla);
  scene.addChild(gruesas);
  return scene;
}
